/**
 * Ensures Petticoat Lane brand-directory links remain reliable across
 * desktop mega-menu and mobile drawer event handling.
 */
(() => {
  const directoryPaths = new Set([
    '/pages/all-brands',
    '/pages/brands-a-z',
    '/pages/all-lingerie-brands',
    '/pages/all-sleepwear-brands',
    '/pages/all-swimwear-brands',
    '/pages/all-apparel-brands'
  ]);

  document.addEventListener('click', (event) => {
    const anchor = event.target.closest?.('a[href]');
    if (!anchor || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    const href = anchor.getAttribute('href');
    if (!href) return;

    if (href.startsWith('#brand-')) {
      const target = document.getElementById(href.slice(1));
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      history.replaceState(null, '', href);
      return;
    }

    let destination;
    try {
      destination = new URL(anchor.href, window.location.origin);
    } catch (_) {
      return;
    }

    if (destination.origin !== window.location.origin || !directoryPaths.has(destination.pathname)) return;

    const startingUrl = window.location.href;
    window.setTimeout(() => {
      if (window.location.href === startingUrl) window.location.assign(destination.href);
    }, 180);
  }, true);
})();